import { render, staticRenderFns } from "./ItemOrder.vue?vue&type=template&id=f1b4e8d8&scoped=true&"
import script from "./ItemOrder.vue?vue&type=script&lang=js&"
export * from "./ItemOrder.vue?vue&type=script&lang=js&"
import style0 from "./ItemOrder.vue?vue&type=style&index=0&id=f1b4e8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b4e8d8",
  null
  
)

export default component.exports